@if (vertraege) {
  @for (vertragsdaten of vertragsdatenEntryVm; track vertragsdaten; let i = $index) {
    <div class="title-divider mt-1 row rubrik-divider mb-2">
      <h3 class="mb-1 mt-0 rubrik-title">
        {{ "vertragsdatensatz" | translate }}
        @if (i < 10) {
          <span>0</span>
        }
        {{ i + 1 }}
      </h3>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement label="Vertragsart">
          {{ vertragsdaten.object.vertragsart?.text | translateName }}
          {{ vertragsdaten.object.vertragsartzusatz }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="vertragsdaten.RechtsgrundArt">
          {{ translateRechtsgrundArt(vertragsdaten.object.rechtsgrundArt) }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="DatumVertragsabschluss">
          {{ vertragsdaten.object.datumVertragsabschluss | datum }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="DatumNutzenUndGefahr">
          {{ vertragsdaten.object.datumNutzenUndGefahr | datum }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="AusserbuchlicherUebergang">
          {{ vertragsdaten.object.datumAusserbuchlicherUebergang | datum }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="KurzdeklarationBeilage">
          {{ vertragsdaten?.object.kurzdeklarationBeilage | yesNo }}
        </cap-kopfdatenelement>
      </div>
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement label="Gesamtpreis">
          @if (vertragsdaten.object.mGesamtPreis.access !== "NONE") {
            <span>
              <span>
                {{ vertragsdaten.object.gesamtPreis | betrag }}
              </span>
            </span>
          } @else {
            <div class="mb-2">
              <span>{{"gemaessGrundbuch" | translate}}</span>
            </div>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="EnthalteneZugaben">
          @if (vertragsdaten.object.mDarinEnthalteneZugaben.access !== "NONE") {
            <span>
              <span>
                {{ vertragsdaten.object.darinEnthalteneZugaben | betrag }}
              </span>
            </span>
          } @else {
            <div class="mb-2">
              <span>{{"gemaessGrundbuch" | translate}}</span>
            </div>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="SonderpreisZugabe">
          @if (vertragsdaten.object.mSonderpreisZugabe.access !== "NONE") {
            <span>
              <span>
                {{ vertragsdaten.object.sonderpreisZugabe | betrag }}
              </span>
            </span>
          } @else {
            <div class="mb-2">
              <span>{{"gemaessGrundbuch" | translate}}</span>
            </div>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="SchulduebernahmeTotal">
          @if (vertragsdaten.object.mSchuldUebernahme.access !== "NONE") {
            <span>
              <span>
                {{ vertragsdaten.object.schuldUebernahme | betrag }}
              </span>
            </span>
          } @else {
            <div class="mb-2">
              <span translate>{{"gemaessGrundbuch" | translate}}</span>
            </div>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement label="UebernahmeGrundstueckgewinnsteuer">
          {{ vertragsdaten?.object.ggUebernahmeDurchErwerber | yesNo }}
        </cap-kopfdatenelement>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <cap-kopfdatenelement [bodyClass]="'col-md-12 col-sm-12'" [labelClass]="'col-md-12 col-sm-12'" label="Bemerkung">
          <div class="row col-md-12" style="padding-left: 8px">
            {{ vertragsdaten.object.bemerkung }}
          </div>
        </cap-kopfdatenelement>
      </div>
    </div>
    @if (isHandaenderungsmeldungOn) {
      @if (!vertragsdaten || vertragsdaten.object.grundstuecke.length === 0) {
        <div class="col-md-12 px-md-0">
          <cap-form-row>
            <div class="col-md-9">
              <h3>
                {{ "BeteiligteGrundstuecke" | translate }}
                @if (i < 10) {
                  <span>0</span>
                }
                {{ i + 1 }}
              </h3>
            </div>
          </cap-form-row>
        </div>
      }
      @if (vertragsdaten.object.grundstuecke) {
        @if (vertragsdaten.object.grundstuecke.length === 0) {
          <ng-template [ngTemplateOutlet]="keine"></ng-template>
        } @else {
          <cap-content-header>
            <cap-title name="title">
              <h3>{{ "BeteiligteGrundstuecke" | translate }}</h3>
            </cap-title>
            <cap-title-functionbar>
              @if (getSelectedGrunstueckeLength(i) > 1) {
                <button (click)="getZip(i)" [disabled]="isZippingInProgress(i)" class="btn btn-outline-primary btn-sm me-2" type="button">
                  @if (isZippingInProgress(i)) {
                    <span class="spinner-border spinner-border-sm text-primary me-1"></span>
                  }
                  {{ "Auszüge" | translate }} {{ "(" + getSelectedGrunstueckeLength(i) + ")" }}
                </button>
              }
            </cap-title-functionbar>
          </cap-content-header>
          <cap-grundstueck-table
            (grundstueckIdsListEventItem)="updateCheckedGrundstueckIdList($event)"
            [indexNumber]="i"
            [listLoader]="vertragsdaten.grundstueckeLoader"
            [showZeilenSelect]="false">
          </cap-grundstueck-table>
        }
      } @else {
        <cap-spinner-small></cap-spinner-small>
      }
    }
    @if (parameterErweiterteGbMeldung && isHandaenderungsmeldungOn) {
      <div class="col-md-9 ps-0 mt-1">
        <h3>
          {{ "Veraeusserer" | translate }}
          @if (i < 10) {
            <span>0</span>
          }
          {{ i + 1 }}
        </h3>
      </div>
      @if (!vertragsdaten || vertragsdaten.veraeusserer?.length == 0) {
        @if (vertragsdaten.object.mErwerberVeraeusserer.access === "NONE") {
          <ng-template [ngTemplateOutlet]="gemGrundbuch"></ng-template>
        }
        @if (vertragsdaten.object.mErwerberVeraeusserer.access !== "NONE") {
          <ng-template [ngTemplateOutlet]="keine"></ng-template>
        }
      } @else {
        <table [attr.aria-label]="'GebäudeeingangsadresseAdressen' | translate" class="cap-table-detail">
          <thead>
            <tr>
              <th>{{"Grundstueck" | translate}}</th>
              <th>{{"Eigentumsform" | translate}}</th>
              <th>{{"vertragsdaten.Eigentuemer" | translate}}</th>
              <th>{{"Zusatzangaben" | translate}}</th>
              <th>{{"Handelsangaben" | translate}}</th>
            </tr>
          </thead>
          <tbody>
            @for (veraeusserer of vertragsdaten.veraeusserer; track veraeusserer) {
              <ng-template [ngTemplateOutlet]="veraeussererTemplate" [ngTemplateOutletContext]="{ veraeusserer: veraeusserer }">
              </ng-template>
            }
            <ng-template #veraeussererTemplate let-veraeusserer="veraeusserer">
              <tr>
                <td>
                  @if (veraeusserer.level == 0) {
                    <span [capHistinfo]="veraeusserer.object.eigentumAnteil?.belastetesGrundstueck.histInfo">
                      <cap-link
                        [queryParams]="{ id: veraeusserer.object.eigentumAnteil?.belastetesGrundstueck.id.id }"
                        [target]="navTargets.NAV_GRUNDSTUECK"
                        [tooltipParams]="{
                          nummer: veraeusserer.object.eigentumAnteil?.belastetesGrundstueck?.grundstueckNummer | grundstuecknummerExtended
                        }">
                        {{ veraeusserer.object.eigentumAnteil?.belastetesGrundstueck | kompaktGrundstueck }}
                      </cap-link>
                    </span>
                  }
                </td>
                <td>
                  @if (veraeusserer.level == 0) {
                    <span [capHistinfo]="veraeusserer.object.eigentumAnteil?.versions[0].histInfo">
                      {{ veraeusserer.object.eigentumAnteil?.versions[0].eigentumsform | translate }}
                    </span>
                  }
                </td>
                <td>
                  <span [ngStyle]="veraeusserer.indent">
                    <cap-kompakt-persongb
                      [auskunftsperre]="veraeusserer.object.auskunftsperre"
                      [capHistinfo]="veraeusserer.object.person?.histInfo"
                      [item]="veraeusserer.object.person"
                      [itemMasterId]="veraeusserer.object.eigentumAnteil?.berechtigtePersonen[0]?.personGbMasterId">
                    </cap-kompakt-persongb>
                  </span>
                </td>
                <td>
                  @for (zusatz of veraeusserer.object.zusatzangaben; track zusatz) {
                    <div>
                      @if (zusatz) {
                        <cap-kompakt-zusatzangaben
                          (openZusatzangabenEvent)="
                            showZusatzangaben(zusatz, veraeusserer.object.person, veraeusserer.object.auskunftsperre, veraeusserer.object)
                          "
                          [referenzObjectId]="referenzObjectId"
                          [zusatzangaben]="zusatz">
                        </cap-kompakt-zusatzangaben>
                      }
                    </div>
                  }
                </td>
                <td>
                  <a
                    (click)="
                      showHandelsangaben(
                        veraeusserer.object.handelsangaben,
                        veraeusserer.object.person,
                        veraeusserer.object.auskunftsperre,
                        veraeusserer.object
                      )
                    "
                    [ngbTooltip]="tooltipHandelsangaben | translate"
                    class="linkAsText"
                    style="cursor: pointer">
                    {{ veraeusserer.object.handelsangaben | kompaktHandelsangaben }}
                  </a>
                </td>
              </tr>
              @for (children of veraeusserer.children; track children) {
                <ng-template [ngTemplateOutlet]="veraeussererTemplate" [ngTemplateOutletContext]="{ veraeusserer: children }">
                </ng-template>
              }
            </ng-template>
          </tbody>
        </table>
      }
      <div class="col-md-9 ps-0 mt-1">
        <h3>
          {{ "Erwerber" | translate }}
          @if (i < 10) {
            <span>0</span>
          }
          {{ i + 1 }}
        </h3>
      </div>
      @if (!vertragsdaten || vertragsdaten.erwerber?.length == 0) {
        @if (vertragsdaten.object.mErwerberVeraeusserer.access === "NONE") {
          <ng-template [ngTemplateOutlet]="gemGrundbuch"></ng-template>
        }
        @if (vertragsdaten.object.mErwerberVeraeusserer.access !== "NONE") {
          <ng-template [ngTemplateOutlet]="keine"></ng-template>
        }
      } @else {
        <table [attr.aria-label]="'GebäudeeingangsadresseAdressen' | translate" class="cap-table-detail">
          <thead>
            <tr>
              <th>{{"Grundstueck" | translate}}</th>
              <th>{{"Eigentumsform" | translate}}</th>
              <th>{{"vertragsdaten.Eigentuemer" | translate}}</th>
              <th>{{"Handelsangaben" | translate}}</th>
            </tr>
          </thead>
          <tbody>
            @for (erwerber of vertragsdaten.erwerber; track erwerber) {
              <ng-template [ngTemplateOutlet]="erwerberTemplate" [ngTemplateOutletContext]="{ erwerber: erwerber }"></ng-template>
            }
            <ng-template #erwerberTemplate let-erwerber="erwerber">
              <tr>
                <td>
                  @if (erwerber.level == 0) {
                    <span [capHistinfo]="erwerber.object.eigentumAnteil?.belastetesGrundstueck.histInfo">
                      <cap-link
                        [queryParams]="{ id: erwerber.object.eigentumAnteil?.belastetesGrundstueck?.id.id }"
                        [target]="navTargets.NAV_GRUNDSTUECK"
                        [tooltipParams]="{
                          nummer: erwerber.object.eigentumAnteil?.belastetesGrundstueck?.grundstueckNummer | grundstuecknummerExtended
                        }">
                        {{ erwerber.object.eigentumAnteil?.belastetesGrundstueck | kompaktGrundstueck }}
                      </cap-link>
                    </span>
                  }
                </td>
                <td>
                  @if (erwerber.level == 0) {
                    <span [capHistinfo]="erwerber.object.eigentumAnteil?.versions[0]?.histInfo">
                      {{ erwerber.object.eigentumAnteil?.versions[0]?.eigentumsform | translate }}
                    </span>
                  }
                </td>
                <td>
                  @if (erwerber.object.person) {
                    <span [ngStyle]="erwerber.indent">
                      <cap-kompakt-persongb
                        [auskunftsperre]="erwerber.object.auskunftsperre"
                        [capHistinfo]="erwerber.object.person.histInfo"
                        [item]="erwerber.object.person"
                        [itemMasterId]="erwerber.object.eigentumAnteil?.berechtigtePersonen[0]?.personGbMasterId">
                      </cap-kompakt-persongb>
                    </span>
                  }
                </td>
                <td>
                  <a
                    (click)="
                      showHandelsangaben(
                        erwerber.object.handelsangaben,
                        erwerber.object.person,
                        erwerber.object.auskunftsperre,
                        erwerber.object
                      )
                    "
                    [ngbTooltip]="tooltipHandelsangaben | translate"
                    style="cursor: pointer">
                    {{ erwerber.object.handelsangaben | kompaktHandelsangaben }}
                  </a>
                </td>
              </tr>
              @for (children of erwerber.children; track children) {
                <ng-template [ngTemplateOutlet]="erwerberTemplate" [ngTemplateOutletContext]="{ erwerber: children }"></ng-template>
              }
            </ng-template>
          </tbody>
        </table>
      }
    }
  }
}

<ng-template #keine>
  <div class="mb-2">
    <span>{{"Keine" | translate}}</span>
  </div>
</ng-template>
<ng-template #gemGrundbuch>
  <div class="mb-2">
    <span>{{"gemaessGrundbuch" | translate}}</span>
  </div>
</ng-template>
